















































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import TagsInput from '@/modules/shared/components/shared/kit/TagsInput.vue'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { InvoiceItemResourceModel } from '@/modules/invoice-item/models/invoice-item-resource.model'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import { AdminInvoiceItemService } from '@/modules/invoice-item/services/admin-invoice-item.service'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: { BaseButton, BaseCard, Checkbox, CurrencyInput, BaseSelect, BaseInput, TagsInput, PriceView }
})
export default class AdminInvoiceItemFormTable extends Vue {
  constructor(
    private readonly service: AdminInvoiceItemService
  ) {
    super()
  }

  @PropSync('items', { required: true }) itemsSync!: InvoiceItemResourceModel[]
  @Prop({ default: false }) noCard!: boolean
  private itemAddIndex = 0

  mounted() {
    this.itemAddIndex =
      (this.itemsSync[0].title === '' && this.itemsSync.length === 1)
        ? this.itemsSync.length - 1
        : this.itemsSync.length
  }

  payable(item): string {
    item.payable = Number(item.price) * Number(item.quantity) - Number(item.discount)
    return item.payable
  }

  addPeriod() {
    this.itemsSync.push({
      discount: 0, payable: 0, price: 0, quantity: 1, title: ''
    })
  }

  removePeriod(index) {
    if (index >= this.itemAddIndex) {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف آیتم',
        message: 'آیا از حذف آیتم اطمینان دارید ؟'
      }).onOk(() => {
        this.itemsSync.splice(index, 1)
      })
    } else {
      alert('not possible')
    }
  }

}
